// Port of api/fuel/app/classes/insights/games/arrivals.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'arrivals',
	priority: 7,
	types: [Constants.TYPE_USER],
	requires: ['init'],
	insight: ['arrivals.type'],
	run: function(type, owner, userIndex, detail, filter) {
		var userId = owner.get_id()
		var firstTouch = this._data.first_touch || {}
		var typeFilter = (filter['arrivals.type'] !== undefined) ? filter['arrivals.type'] : 'all'
		var filtered = {}

		var touchKeys = Object.keys(firstTouch)
		for (var i = 0; i < touchKeys.length; i++) {
			var key = touchKeys[i]
			if (typeFilter === 'all' || firstTouch[key].type === typeFilter) filtered[key] = firstTouch[key]
		}

		if (!Object.keys(filtered).length) return { arrivals: [], arrivalsTotal: 0 }

		var sortedKeys = Object.keys(filtered).sort(function(a, b) {
			return filtered[b].date - filtered[a].date
		})

		var limit = detail ? 100 : 5
		var recentKeys = sortedKeys.slice(0, limit)
		var ownedMap = {}
		var ratedMap = {}

		if (recentKeys.length) {
			var ownedRows = Util.queryFast(
				'SELECT c.game_id AS g, c.collection_own AS own, c.collection_prevowned AS prevowned FROM collection c' +
				' WHERE c.user_id = ' + userId + ' AND c.game_id IN (' + Util.in(recentKeys) + ')'
			)
			for (var or = 0; or < ownedRows.length; or++) {
				ownedMap[parseInt(ownedRows[or].g, 10)] = {
					own: parseInt(ownedRows[or].own, 10),
					prevowned: parseInt(ownedRows[or].prevowned, 10)
				}
			}

			var ratedRows = Util.queryFast(
				'SELECT r.game_id AS g FROM rating r WHERE r.user_id = ' + userId + ' AND r.game_id IN (' + Util.in(recentKeys) + ')'
			)
			for (var rr = 0; rr < ratedRows.length; rr++) ratedMap[parseInt(ratedRows[rr].g, 10)] = true
		}

		var arrivals = []
		for (var j = 0; j < recentKeys.length; j++) {
			var gid = parseInt(recentKeys[j], 10)
			var ownData = ownedMap[gid] || { own: 0, prevowned: 0 }
			arrivals.push({
				g: gid,
				date: filtered[gid].date,
				type: filtered[gid].type,
				own: ownData.own,
				prevowned: ownData.prevowned,
				rated: ratedMap[gid] ? 1 : 0
			})
			this._references.games.push(gid)
		}

		return {
			arrivals: arrivals,
			arrivalsTotal: Object.keys(filtered).length
		}
	}
})
